import listening from "./../assets/images/listeningYAS.svg";
import moozik from "./../assets/images/moozik.svg";
import screenShotMultipleFilterBlueTintShort from "./../assets/images/screenShotMultipleFilterBlueTintShortYAS.png";
import Header from "../components/Header";
import phoneWhite from "./../assets/images/phoneWhite.svg";
import { useCallback, useEffect, useState, useMemo } from "react";
import { isTelmaMSISDN } from "../utils/msisdn";
import { useLocation, useNavigate } from "react-router-dom";
import MoozikServices from "../services/http/MoozikServices";
import { useMsisdnContext } from "../context/MsisdnContext";
import { MoonLoader } from "react-spinners";

const Identification = () => {
  const [loading, setLoading] = useState(false);
  const [telmaNum, setTelmaNum] = useState("");
  const canSubmit = useMemo(() => isTelmaMSISDN(telmaNum), [telmaNum]);
  const { setMsisdn } = useMsisdnContext();

  const navigate = useNavigate();
  const { state } = useLocation();

  const handleIdentification = useCallback(async () => {
    if (loading || !canSubmit) return;

    setLoading(true);
    try {
      setMsisdn(telmaNum);
      const identify = await MoozikServices.identifyMsisdn({
        msisdn: telmaNum,
        rpid: state?.rpid,
      });
      console.log("====================================", identify);
      if (identify?.statuscode !== 200) {
        console.log("====================================");
        console.log("[!] erreur identification");
        console.log("====================================");
      }
      navigate("/verif", {
        state: {
          ...state,
          msisdn: telmaNum,
        },
      });
    } catch (error) {
      console.log("error", JSON.stringify(error, null, 3));
      console.log("error", error);
      alert("Une erreur est survenue, veuillez réessayer plus tard.");
    } finally {
      setLoading(false);
    }
  }, [loading, canSubmit, setMsisdn, telmaNum, state, navigate]);

  // verif param navigation
  useEffect(() => {
    if (!state) {
      navigate("/");
    } else if (state && (!state.rpid || !state.offername || !state.amount)) {
      navigate("/");
    }
  }, [navigate, state]);

  return (
    <div className="min-h-screen flex justify-center bg-whitesmoke-300">
      <div className="max-w-[641px] w-full bg-[#00377D] h-auto overflow-hidden text-left text-base text-white font-montserrat">
        <Header hideMsisdn />
        <div className="relative top-[20px] left-[0px] w-[100%] h-[fit-content] [background:#123274]">
          <img
            className="relative top-[-55px] w-[100%] object-contain"
            alt=""
            id="image_"
            src={listening}
          />
          <img
            className="relative top-[0px] w-[100%] object-cover"
            alt=""
            src={screenShotMultipleFilterBlueTintShort}
          />
          <div className="absolute top-[15%] left-[5%] right-[5%] w-auto z-5">
            <img
              className="relative w-[102px] h-[102px] object-cover"
              alt=""
              src={moozik}
            />

            <div className="relative text-[33px] mt-20 mb-7 leading-[42px] uppercase font-[700] text-whitesmoke-200">
              <p className="m-0 z-10">{`IDENTIFICATION `}</p>
            </div>
            <div className="relative z-5 w-auto flex items-center justify-center flex-col">
              <div className="border border-solid border-white bg-transparent w-[85%] h-[45px] rounded-[30px] flex items-center flex-row px-4 justify-between">
                <img
                  className="w-4 h-4 overflow-hidden"
                  alt=""
                  src={phoneWhite}
                />
                <input
                  value={telmaNum}
                  onChange={(e) => setTelmaNum(e.target.value)}
                  type="tel"
                  className="flex-grow ml-2 bg-transparent focus:outline-none text-white placeholder:text-white placeholder:font-montserrat placeholder:text-[12px]"
                  placeholder="N° d'identification(034 ou 038 ou 036)"
                />
              </div>
              <div
                onClick={handleIdentification}
                className={`cursor-pointer w-[85%] h-[45px] rounded-[30px] flex items-center flex-row px-4 justify-center mt-8 uppercase text-black font-[700] bg-gold-200 [color:#00377D] ${
                  !canSubmit && "bg-slate-500"
                }`}
              >
                {!loading ? (
                  "IDENTIFIER"
                ) : (
                  <MoonLoader size={20} color="black" />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="text-center relative bottom-10 left-0 right-0 text-white text-[10px] z-10">{`Copyright DIGITAL TELMA 2024`}</div>
      </div>
    </div>
  );
};

export default Identification;
